import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'

export interface AppNotification {
  id: string
  user_id: string
  type: string
  title: string
  message?: string
  is_read: boolean
  link?: string
  entity_type?: string
  entity_id?: string
  created_at: string
}

interface NotificationList {
  items: AppNotification[]
  total: number
  unread_count: number
}

export function useNotifications(page = 1, perPage = 20) {
  return useQuery({
    queryKey: ['notifications', page, perPage],
    queryFn: async () => {
      const { data } = await api.get<NotificationList>('/v1/notifications/', { params: { page, per_page: perPage } })
      return data
    },
    refetchInterval: 30000, // Poll every 30s
  })
}

export function useUnreadCount() {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      const { data } = await api.get<{ unread_count: number }>('/v1/notifications/unread-count')
      return data.unread_count
    },
    refetchInterval: 30000,
  })
}

export function useMarkAsRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (notificationId: string) => {
      await api.post(`/v1/notifications/${notificationId}/read`)
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}

export function useMarkAllAsRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await api.post('/v1/notifications/read-all')
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}
